// apiService.js
import { toast } from 'react-toastify';
import { getAuth } from 'firebase/auth';

export const getToken = async () => {
  const auth = getAuth();
  const user = auth.currentUser;

  if (user) {
    try {
      // Force refresh only if necessary (true), otherwise use cached token
      const idToken = await user.getIdToken();
      if(idToken === undefined){
        idToken = await user.getIdToken(true);
        console.log('refresh token:'+idToken)
      }
      return idToken;
    } catch (error) {
      console.error(`Error getting token: ${error}`);
      toast.error(`Error getting token: ${error}`);
    }
  }
  return null;
};

/**
 * Custom error class for API-specific failures
 */
class ApiError extends Error {
  constructor(message, status, data) {
    super(message);
    this.name = "ApiError";
    this.status = status;
    this.data = data;
  }
}

const BASE_URL = process.env.REACT_APP_API_SERVER_URL ?? '/api/';

/**
 * Base request handler with built-in error & exception handling
 */
async function request(endpoint, options = {}) {
  const url = `${BASE_URL}${endpoint}`;
  const idToken = await getToken();

  const headers = {
    'Authorization': `Bearer ${idToken}`,
    ...options.headers,
  };
  if (!headers['Content-Type'] && (!options || options?.input!='FILE')){
    headers['Content-Type'] = 'application/json';
  }

  const config = {
    ...options,
    headers,
  };

  try {
    console.log(config)
    const response = await fetch(url, config);
    console.log(response);

    // Handle "Not OK" responses (e.g., 400, 401, 404, 500)
    if (!response.ok) {
      let errorData;
      try {
        errorData = await response.json();
      } catch {
        errorData = { message: 'Unexpected error format from server' };
      }

      // Best practice: Throw a structured error for the catch block to handle
      throw new ApiError(
        errorData.message || `Request failed with status ${response.status}`,
        response.status,
        errorData
      );
    }

    // Success: Return parsed JSON or null if no content
    var result = null;
    if (response.status === 204) result = null
    else if (options?.output=='BLOB') result = {blob: await response.blob(), filename: await get_disposition_filename(response) }
    else result = await response.json()
    return [result, null];

  } catch (error) {
    // Distinguish between API errors and network/client-side exceptions
    if (error instanceof ApiError) {
      console.error(`[API Error] ${error.status}: ${error.message} - ${JSON.stringify(error.data)} `);
      toast.error(`[API Error] ${error.status}: ${error.message} - ${JSON.stringify(error.data)} `);
    } else {
      console.error(`[Network/Client Error]: ${error.message}`);
      toast.error(`Network error. Please check your connection: ${error.message} `);
    }

    // Re-throw so the calling component can also handle the error state
    //throw error;
    return [null, error];
  }
}

async function get_disposition_filename(response){
  // filename
  const disposition = await response.headers.get('Content-Disposition');
  //const disposition = await response.headers.get('content-disposition');
  console.log("disposition:" + disposition);
  let filename = "download.docx"; // Fallback name
  if (disposition && disposition.includes('attachment')) {
    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
    const matches = filenameRegex.exec(disposition);
    if (matches != null && matches[1]) {
      // Remove quotes if present
      filename = matches[1].replace(/['"]/g, '');
    }
  }
  return filename;
}

// Exported methods for convenience
export const api = {
  get: (endpoint, options) => request(endpoint, { ...options, method: 'GET' }),
  getblob: (endpoint, options) => request(endpoint, { ...options, method: 'GET',output:'BLOB' }),
  post: (endpoint, body, options) => request(endpoint, {
    ...options,
    method: 'POST',
    body: JSON.stringify(body)
  }),
  postEncoded: (endpoint, params, options) => request(endpoint, {
      ...options,
      method: 'POST',
      headers: {
            ...options?.headers,
            'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: params.toString()
  }),
  put: (endpoint, body, options) => request(endpoint, {
    ...options,
    method: 'PUT',
    body: JSON.stringify(body)
  }),
  patch: (endpoint, body, options) => request(endpoint, {
    ...options,
    method: 'PATCH',
    body: JSON.stringify(body)
  }),
  delete: (endpoint, options) => request(endpoint, { ...options, method: 'DELETE' }),
  postFile: (endpoint, body, options) => request(endpoint, {
    ...options,
    method: 'POST',
    body: body,
    input:'FILE'
  }),
};
